type SearchTimePreset = '1h' | '24h' | '7d' | 'all' | 'custom';

/** Earliest practical radacct window (API only requires from < to). */
const ALL_TIME_SEARCH_FROM = '1970-01-01T00:00:00Z';

const PRESET_MS: Record<Exclude<SearchTimePreset, 'all' | 'custom'>, number> = {
  '1h': 60 * 60 * 1000,
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
};

const SEARCH_TIME_PRESET_LABELS: Record<SearchTimePreset, string> = {
  '1h': 'Last 1 hour',
  '24h': 'Last 24 hours',
  '7d': 'Last 7 days',
  all: 'All time',
  custom: 'Custom range',
};

const buildSearchTimeWindow = (
  preset: Exclude<SearchTimePreset, 'custom'>,
  now: Date = new Date(),
): { from: string; to: string } => {
  if (preset === 'all') {
    return { from: ALL_TIME_SEARCH_FROM, to: now.toISOString() };
  }

  const to = now.toISOString();
  const from = new Date(now.getTime() - PRESET_MS[preset]).toISOString();

  return { from, to };
};

const validateSearchTimeWindow = (from: string, to: string): string | null => {
  const fromDate = new Date(from);
  const toDate = new Date(to);

  if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
    return 'Invalid date range';
  }

  if (fromDate >= toDate) {
    return "'From' must be earlier than 'To'.";
  }

  return null;
};

const isAllTimeSearchWindow = (from: string) => from === ALL_TIME_SEARCH_FROM;

export type { SearchTimePreset };
export { SEARCH_TIME_PRESET_LABELS, buildSearchTimeWindow, isAllTimeSearchWindow, validateSearchTimeWindow };
